import psHttp, { RequestChannel, psHttp$ } from '@patsnap/common-ps-http';
import { coreSearchApiUrlPrefix } from '../../config/constants';
import { upperCase } from 'lodash';
import jsCookie from 'js-cookie';
const X_SITE_LANG = upperCase(jsCookie.get('database_locale_') || 'en');

const getNewHistoryRecordsChannel = new RequestChannel(psHttp$);
export function getNewHistoryRecordsApi({
    page = 1,
    q,
    duration,
    tzOffset,
    start,
    end
}) {
    return getNewHistoryRecordsChannel.requestAsPromise({
        url: `${coreSearchApiUrlPrefix}/history/search/list`,
        params: {
            page,
            q,
            duration,
            tzOffset,
            start,
            end
        },
        headers: {
            'X-Site-Lang': X_SITE_LANG,
        },
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data || {};
    });
}


export function getHistoryRecordsApi({
    type,
    page = 1,
    q,
    duration,
    tzOffset,
    start,
    end
}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/history/records`,
        params: {
            type,
            page,
            q,
            duration,
            tzOffset,
            start,
            end
        },
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function deleteHistoryApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/history/`,
        data,
        method: 'DELETE',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function exportHistoryRecordsApi({
    tzOffset,
    data
}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/history/export/${tzOffset}`,
        method: 'POST',
        data: {
            data
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function convertQueryApi({ query }) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/history/query`,
        method: 'POST',
        data: {
            query
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function getOrignDocApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/origin/doc`,
        method: 'POST',
        data,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function writePatentHistroyApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/history`,
        method: 'POST',
        data,
        headers: {
            'X-API-Version': '1.0'
        }
    });
}
